import { gql } from "@apollo/client";

const GET_DEDUCTION_TYPES = gql`
  query GetDeductionTypes {
    types {
      count
      items {
        id
        parentId
        deductionName
        deductionTypeKey
      }
    }
  }
`;

export default GET_DEDUCTION_TYPES;
